import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { User } from 'models/user';
import TableHeader from 'components/TableHeader';
import { formatFilter } from 'utils/format';
import {
    createColumnHelper,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table';
import Table from 'components/Table';

interface UserTableProps {
    users: User[];
    allowCreate: boolean;
}

const userColumnHelper = createColumnHelper<User>();

const getUserColumns = () => [
    userColumnHelper.accessor('name', {
        header: 'Name',
    }),
    userColumnHelper.accessor((row) => `${row.username} (${row.id})`, {
        header: 'Username (ID)',
        cell: (props) => (
            <>
                {props.row.original.username + ' ('}
                <a
                    href={`https://flightaware.com/admin/view_user.rvt?queryuser=${props.row.original.username}`}
                    target="_blank"
                    rel="noreferrer"
                    title="view user in fa_web"
                >
                    {props.row.original.id}
                </a>
                {')'}
            </>
        ),
    }),
    userColumnHelper.accessor((row) => formatFilter(row.permissions.filters.operators), {
        header: 'Operator Permissions',
    }),
    userColumnHelper.accessor((row) => formatFilter(row.permissions.filters.airports), {
        header: 'Airport Permissions',
    }),
    userColumnHelper.accessor((row) => formatFilter(row.permissions.filters.registrations), {
        header: 'Registration Permissions',
    }),
    userColumnHelper.accessor('id', {
        header: 'Manage',
        cell: (props) => (
            <Link to={`/admin/users/${props.row.original.id}/edit`} title="manage user">
                manage
            </Link>
        ),
        enableSorting: false,
        enableGlobalFilter: false,
    }),
];

const UserTable: FC<UserTableProps> = (props) => {
    const table = useReactTable({
        data: props.users,
        columns: getUserColumns(),
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        initialState: {
            pagination: {
                pageSize: 5,
            },
        },
    });

    return (
        <>
            <TableHeader tableType="user" allowCreate={props.allowCreate} />
            {props.users.length ? <Table table={table} type="user" /> : <div>No users found</div>}
        </>
    );
};

export default UserTable;
